export default __webpack_public_path__ + "android_installation.webp";